import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Tooltip } from '../../../common/tooltip'

export const CustomThTooltip = ({ value }) => {
  const renderTooltipContent = () => {
    return (
      <Element elementName="p" style={{ textAlign: 'center' }}>
        <Translate value="library.detailsPortfolios.TEXT_INF_ICON" />
      </Element>
    )
  }
  return (
    <div className="dFlex">
      <Element elementName="p">
        <Translate value={value} style={{ paddingRight: 6 }} />
      </Element>
      <Tooltip tooltipContent={renderTooltipContent()}>
        <Icon
          className="icon-info-circle"
          style={{ color: '#9C9C9C', fontSize: 14 }}
        />
      </Tooltip>
    </div>
  )
}
